var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfiledropdownAppregions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.827,
    height: 20.867,
    viewBox: "0 0 16.827 20.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(-4.049 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_212845008",
    transform: "translate(4.299 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_212846016",
    d: "M12.463,35.25a14.85,14.85,0,0,1-5.7-1.021C5.173,33.545,4.3,32.613,4.3,31.6c0-.857.62-1.652,1.794-2.3a12.046,12.046,0,0,1,4.314-1.231.222.222,0,1,1,.051.442c-3.311.376-5.714,1.675-5.714,3.089,0,.808.8,1.616,2.191,2.216a14.4,14.4,0,0,0,5.527.984,14.4,14.4,0,0,0,5.527-.984c1.392-.6,2.191-1.408,2.191-2.216,0-1.414-2.4-2.713-5.714-3.089a.222.222,0,0,1,.05-.442A12.042,12.042,0,0,1,18.831,29.3c1.174.648,1.795,1.443,1.795,2.3,0,1.009-.874,1.941-2.46,2.625a14.85,14.85,0,0,1-5.7,1.021Z",
    transform: "translate(-4.299 -14.883)",
    stroke: "#000",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_212846232",
    d: "M20.29,7.568a.56.56,0,1,0,.559.56A.56.56,0,0,0,20.29,7.568Zm0,1.5a.943.943,0,1,1,.943-.943A.944.944,0,0,1,20.29,9.071Z",
    transform: "translate(-12.106 -3.708)",
    stroke: "#000",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_212846208",
    d: "M18.045,13.7h2.484v-.61a.607.607,0,0,0-.641-.609,1.187,1.187,0,0,1-1.2,0,.607.607,0,0,0-.641.609Zm2.676.383H17.853a.192.192,0,0,1-.192-.192v-.8a.993.993,0,0,1,1.077-.994.191.191,0,0,1,.105.032.815.815,0,0,0,.886,0,.191.191,0,0,1,.105-.032.993.993,0,0,1,1.077.994v.8A.192.192,0,0,1,20.72,14.081Z",
    transform: "translate(-11.161 -6.73)",
    stroke: "#000",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_212845560",
    d: "M15.083.445a5.4,5.4,0,0,0-5.4,5.4c0,1.721,2.655,6,4.412,8.839.376.607.711,1.147.985,1.6.273-.456.609-1,.985-1.6,1.757-2.834,4.412-7.118,4.412-8.839a5.4,5.4,0,0,0-5.4-5.4Zm0,16.5a.223.223,0,0,1-.192-.11c-.3-.511-.7-1.163-1.17-1.918C11.83,11.866,9.241,7.69,9.241,5.842a5.842,5.842,0,1,1,11.684,0c0,1.848-2.589,6.024-4.479,9.074-.468.755-.872,1.407-1.171,1.918a.222.222,0,0,1-.192.11Z",
    transform: "translate(-6.919 0)",
    stroke: "#000",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_212845080",
    d: "M17.518,4.7a3.239,3.239,0,1,0,3.239,3.239A3.242,3.242,0,0,0,17.518,4.7Zm0,6.922A3.683,3.683,0,1,1,21.2,7.936,3.687,3.687,0,0,1,17.518,11.62Z",
    transform: "translate(-9.335 -2.255)",
    stroke: "#000",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfiledropdownAppregions);
export default __webpack_public_path__ + "static/media/profiledropdown-appregions.818e3e6ee3eeeea80580c35f1901c96b.svg";
export { ForwardRef as ReactComponent };